import { Map } from 'immutable';
import { createAction, handleActions } from 'redux-actions';
export const actions = {
    REQUEST: createAction('ACCOUNTS/LOGOUT/REQUEST'),
    SUCCESS: createAction('ACCOUNTS/LOGOUT/SUCCESS'),
    ERROR: createAction('ACCOUNTS/LOGOUT/ERROR'),
};
export const initialState = Map({
    isProcessing: false,
    error: null,
});
const reducer = handleActions({
    [actions.REQUEST]: (state) => state.merge({ isProcessing: true, error: false }),
    [actions.SUCCESS]: (state, action) => state.merge({
        isProcessing: false,
        error: false,
    }),
    [actions.ERROR]: (state) => state.merge({ isProcessing: false, error: true }),
}, initialState);
export default reducer;
export const isProcessingSelector = (state) => state.logout.get('isProcessing');
export const errorSelector = (state) => state.logout.get('error');
